import React, { useCallback } from 'react'
import { I18n } from '@front/volcanion/'

import { TableHeader, TableRow, SearchFrame, SearchForm, SearchTable, FormContent } from '@front/squirtle'
import { Box, Typography, StepLabel, StepContent } from '@mui/material'

import Callbacks from './callbacks'

import Form from './Form'
import Header from './Header'
import Row from './Row'

const ServiceSection = ({ record_id, enableSubmitAll }) => {
  const filterToForm = useCallback(Callbacks.filterToFormHandler(), [])
  const formToFilter = useCallback(Callbacks.formToFilterHandler(record_id), [record_id])
  const filterToState = useCallback(Callbacks.filterToStateHandler(record_id), [record_id])
  const formToRecord = useCallback(Callbacks.formToRecordHandler(record_id), [record_id])
  const recordToForm = useCallback(Callbacks.recordToFormHandler(), [])

  return <>
    <StepLabel>
      <Typography variant={'h5'}>{I18n.t('traffic_alert.config.label')}</Typography>
    </StepLabel>
    <StepContent >
      <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
        <SearchFrame
          model_name={'trafficalertconfig'}
          populate={[]}
          sort={['priority ASC']}
          allowCreate={false}
          createPlacement={'bottom'}
        >
          <SearchForm
            filterToForm={filterToForm}
            formToFilter={formToFilter}
            filterToState={filterToState}
            submitOnMount={!!record_id}
            submitOnEnter={false}
            disableButton
          >
            <FormContent><Form /></FormContent>
          </SearchForm>
          <SearchTable
            formProps={{
              recordToForm,
              formToRecord,
              disableParentSubmitListener: true
            }}
            formActionsProps={{
              enableSubmitAll
            }}
            tableProps={{
              allowEditMode: true,
              enablePagination: false,
              enableRowActions: true,
              enableGlobalActions: true,
              enableGlobalActionsPlacement: 'bottom',
              addRowLabel: I18n.t('traffic_alert.config.add')
            }}
          >
            <TableHeader><Header /></TableHeader>
            <TableRow ><Row /></TableRow>
          </SearchTable>
        </SearchFrame >
      </Box>
    </StepContent>
  </>
}

export default React.memo(ServiceSection)
